import { axiosPrivate } from '@app/dashboard/tools/axios/axiosInstance';

export const fetchCampaignStatics = async (campaignId: string) => {
  return axiosPrivate.get(
    `/reach/bulk_upload_campaign_results_statistics/?campaign_id=${campaignId}`
  );
};

export const fetchSingleCampaign = async (campaignId: string) => {
  return axiosPrivate.get(
    `/reach/bulk_upload_campaign_retrive/?campaign_id=${campaignId}`
  );
};

export const terminateCampaign = async (campaignId: string) => {
  return axiosPrivate.post(
    `/reach/bulk_upload_terminate_campaign/?campaign_id=${campaignId}`
  );
};
